import { render, staticRenderFns } from "./ProductImagesManager.vue?vue&type=template&id=04420a58"
import script from "./ProductImagesManager.vue?vue&type=script&lang=js"
export * from "./ProductImagesManager.vue?vue&type=script&lang=js"
import style0 from "./ProductImagesManager.vue?vue&type=style&index=0&id=04420a58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports